import buildService, { NoParams } from 'common/utils/build-service'
import { DELETE, GET, PATCH, POST } from 'common/requests'

interface SubjectIdParams {
  id: string
}

export default buildService<NoParams, unknown, unknown, unknown>({
  type: GET,
  constantsPrefix: 'SUBJECTS',
  isArray: true,
  http: {
    createApiUrlSuffix: () => '/subjects?select=id,slug,name&order=name.asc',
  },
})

export const postSubjectService = buildService<NoParams, unknown, unknown, unknown>({
  type: POST,
  constantsPrefix: 'SUBJECTS',
  http: {
    createApiUrlSuffix: () => {
      return `/subjects`
    },
  },
})

export const deleteSubjectService = buildService<SubjectIdParams, unknown, unknown, unknown>({
  type: DELETE,
  constantsPrefix: 'SUBJECTS',
  http: {
    createApiUrlSuffix: ({ id }) => {
      return `/subjects?id=eq.${id}`
    },
  },
})

export const patchSubjectService = buildService<SubjectIdParams, unknown, unknown, unknown>({
  type: PATCH,
  constantsPrefix: 'SUBJECTS',
  http: {
    createApiUrlSuffix: ({ id }) => `/subjects?id=eq.${id}`,
  },
})
